import logo from '../logo.svg';
import '../App.css';
import '../waitlist.css';
import bgImg from "../img/bg.jpg";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from 'axios';
import * as motion from "motion/react-client"
import Logo from "../img/rouzo-logo.png"

function WaitlistPage() {

  let [mobileNumber, setMobileNumber] = useState(null);
  let [fullName, setFullName] = useState(null);
  let [why, setWhy] = useState(null);
  let [loading, setIsLoading] = useState(false);
  let [formActive, setFormActive] = useState(false);

  let submitWaitlist = async () => {
    window.location.href = "https://forms.gle/PCgKfqj38wA2UU9G8";
    return;
    if (loading) {
      return
    }
    setIsLoading(true);
    //toast.error("tee")
    try {
      let req = await axios.post('https://rouzo-x-1.onrender.com/waitlist/new', {
        mobileNumber,
        fullName,
        whyWillYouUseThis: why
      });

      if (req.status === 200) {
        toast.success('Successfully joined the waitlist!');
      } else {
        toast.error('Failed to join the waitlist. Please try again.');
      }

      console.log(mobileNumber)
      console.log(fullName)
      console.log(why)
      setTimeout(() => {
        setIsLoading(false)
      }, 2000);
    }
    catch (e) {
      console.log(e)
      toast.error('Failed to join the waitlist. Please try again.');
      setTimeout(() => {
        setIsLoading(false)
      }, 2000);
    }

  }

  let popupForm = async () => {
    setFormActive(true);
  }


  return (
    <div>
      <div className='logo'>
        <img height={"100px"} src={Logo}></img>
      </div>

      <div style={{ backgroundSize: "contain", backgroundPosition: 'center', height: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="App">
        <div>
          <div className='trialLarge'>
            <div style={{ textAlign: "left" }}>
              <p style={{ fontSize: "50px", margin: "0px", color: "black" }}>Do you want to <br></br>supercharge customer<br></br> acquisition and sales?</p>
              <p style={{ fontSize: "20px", color: "black" }}>We are building the tool you need to grow.</p>
            </div>
            <div className="flex ">
              <div className="waitlistPill" style={{ background: "#2709bb" }}>
                <p className="richTasteFont">Set Goals</p>
                <p>Choose your sales target, and we’ll help you hit it</p>
              </div>
              <div className="waitlistPill" style={{ background: "#c10f0f", textAlign: "right" }}>
                <p className="richTasteFont">Manage your funnels</p>
                <p>Sell on Instagram, WhatsApp, Facebook, in-store, or through affiliates—all in one place</p>
              </div>
              <div className="waitlistPill" style={{ background: "#ff9c01" }}>
                <p className="richTasteFont">Go Pro</p>
                <p>See what’s working for your business and where to grow.</p>
              </div>
            </div>

            {/*<div className='richTasteFont' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <div style={{ display: "flex" }}>
              <div style={{ textAlign: "left" }}>

                <span style={{ fontSize: "180px", textAlign: 'center', color: "white" }}>ROU </span>
                <br></br>
                <span id='zo' style={{ position: "relative",  fontSize: "180px", textAlign: 'center', color: "white" }}>
                  ZO
                  <span style={{ fposition: "relative", top: "50px", fontSize: "20px", textAlign: "center" }}>
                    -
                  </span>
                  <span style={{ color: "#2709bb" }}>X</span>
                </span>
              </div>

            </div>
            

          </div>
            */}

            <button onClick={() => submitWaitlist()} className="waitlistBtn richTasteFont" >Join The Wait</button>

          </div>

          {formActive ?
            <motion.div animate={{ top: "50%", left: "50%" }} transition={{ type: "spring" }} className="waitlistForm">
              <div style={{ background: 'rgba(84, 85, 120, 0.42)', textAlign: "left", borderRadius: '20px', backdropFilter: 'blur(10px)' }}>
                <div style={{ padding: "20px" }}>

                  <div style={{ marginBottom: '10px', }}>
                    <label >Name</label>
                    <br>
                    </br>
                    <input onChange={(e) => setFullName(e.target.value)} type="text" name="name" />
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <label >Phone Number </label>
                    <br></br>
                    <input onChange={(e) => setMobileNumber(e.target.value)} type="text" name="phone" />
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <label >Why would you use our product ?</label>
                    <br></br>
                    <textarea onChange={(e) => setWhy(e.target.value)} type="number" name="text" />
                  </div>
                  {loading ?
                    <button className="waitlistBtn richTasteFont">Submitting ..</button>
                    :
                    <button onClick={() => submitWaitlist()} className="waitlistBtn richTasteFont">Submit</button>
                  }

                </div>

              </div>
            </motion.div>
            : ""
          }

        </div>

      </div>
    </div>

  );
}

export default WaitlistPage;

/*

RouzoX
Your Business Growth Companion  

We are building the tool you need to grow.

- Set Goals: Choose your sales target, and we’ll help you hit it.  
- Manage your funnels: Sell on Instagram, WhatsApp, Facebook, in-store, or through affiliates—all in one place.  
- Go Pro: See what’s working for your business and where to grow.  

Join the waitlist now for exclusive early access!
*/